import { render, staticRenderFns } from "./KaiWord.vue?vue&type=template&id=54f56ab9&scoped=true&"
import script from "./KaiWord.vue?vue&type=script&lang=ts&"
export * from "./KaiWord.vue?vue&type=script&lang=ts&"
import style0 from "./KaiWord.vue?vue&type=style&index=0&id=54f56ab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f56ab9",
  null
  
)

export default component.exports